import { render, staticRenderFns } from "./SlaColorBlock.vue?vue&type=template&id=2fe9773e&scoped=true"
import script from "./SlaColorBlock.vue?vue&type=script&lang=js"
export * from "./SlaColorBlock.vue?vue&type=script&lang=js"
import style0 from "./SlaColorBlock.vue?vue&type=style&index=0&id=2fe9773e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe9773e",
  null
  
)

export default component.exports